// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* This is for documentation purposes and will not be needed in your application */\n#create .v-speed-dial {\n  position: fixed;\n  bottom: 100px;\n}\n#create .v-btn--floating {\n  position: relative;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
